import axios from "axios";
export { vehicleCategoriesActions };

axios.defaults.withCredentials = true;

function vehicleCategoriesActions() {
  const baseUrl = ``;
  const tenantVal = `${process.env.REACT_APP_TENANT}`;

  return {
    getCarCompaniesQueryParams,
    exportData,
    update,
  };

  async function getCarCompaniesQueryParams( params: any) {
    return axios.get(`${baseUrl}/masterdatavehicle/categorization`, {
      params: params,
    });
  }

  async function exportData(params:any
  ) {
    return await axios.get(
      `${baseUrl}/masterdatavehicle/categorization/excel`,
      {
        params: params,
        responseType: "arraybuffer",
      }
    );
  }

  async function update(tenant:string,vehicleCategories: any) {
    return axios.put(
      `${baseUrl}/masterdatavehicle/categorization`,
      vehicleCategories,
      {params:{tenant:tenant}})
  }
}
